import React from "react";
import Signup from "./Components/Signup/Signup.js";
import Login from "./Components/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
import Welcome from "./Components/Welcome/Welcome";
import PwReset from "./Components/PwReset/PwReset.js";
import NotFound from "./Components/NotFound/NotFound";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import CssBaseLine from "@material-ui/core/CssBaseline";
import lightBlue from "@material-ui/core/colors/lightBlue";
import {
  createMuiTheme,
  ThemeProvider,
  responsiveFontSizes
} from "@material-ui/core/styles";

const appTheme = responsiveFontSizes(
  createMuiTheme({
    palette: {
      primary: {
        main: lightBlue[700]
      },
      type: "dark"
    }
  })
);
class App extends React.Component {
  render() {
    return (
      <ThemeProvider theme={appTheme}>
        <CssBaseLine />
        <BrowserRouter>
          <Switch>
            <Route path="/" component={Dashboard} exact></Route>
            <Route path="/signup" component={Signup}></Route>
            <Route path="/login" component={Login}></Route>
            <Route path="/dashboard" component={Dashboard}></Route>
            <Route path="/pwreset" component={PwReset}></Route>
            <Route path="/welcome" component={Welcome}></Route>
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}
export default App;
